import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LeftNavComponent } from './shared/left-nav/left-nav.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AuthenticateComponent } from './shared/authenticate/authenticate.component';
import { HashLocationStrategy, LocationStrategy, APP_BASE_HREF } from '@angular/common';
import { DashboardModule } from './dashboard/dashboard.module';
import { UserModule } from './user/user.module';
import { CommonService } from './services/common.service';
import { AuthService } from './services/auth.service';
import { ValidationService } from './services/validation.service';
import { FormGroup,FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AuthGuard } from './guard/auth.guard';
import { PagerService } from './services/index';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'underscore';

//import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CitySurveyComponent } from './city-survey/city-survey.component';
import { AskWazzersComponent } from './ask-wazzers/ask-wazzers.component';
@NgModule({
  declarations: [
    AppComponent,
    LeftNavComponent,
    HeaderComponent,
    FooterComponent,
    AuthenticateComponent,
    CitySurveyComponent,
    AskWazzersComponent
  ],
  imports: [
    BrowserModule,HttpModule, DashboardModule, UserModule, ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    RouterModule.forRoot([])
    
    //DatepickerModule.forRoot()
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy },
    CommonService,
    AuthService,
    ValidationService,PagerService,
    AuthGuard,CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/app.module.ts